import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  c: () => (/* binding */ IconBenefitsMoisturewicking)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/IconBenefitsMoisturewicking.tsx


const IconBenefitsMoisturewicking = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-benefits-moisturewicking-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("title", { children: 'Moisture Wicking Icon ' }), (0,jsx_runtime.jsx)("desc", { children: 'Created with Sketch.' }), (0,jsx_runtime.jsx)("defs", {}), (0,jsx_runtime.jsx)("g", Object.assign({ id: "Spots-Flow", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Icons-", transform: "translate(-507.000000, -349.000000)", fill: "#00285E" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Moisture-Wicking-Icon-", transform: "translate(508.000000, 349.000000)" }, { children: (0,jsx_runtime.jsxs)("g", { children: [(0,jsx_runtime.jsx)("path", { d: "M14.7932927,21.7090976 C14.4435366,22.425439 14.0264634,23.3788537 14.0264634,23.6803171 C14.0264634,23.8851951 14.1069512,24.0769024 14.2518293,24.2225122 C14.3959756,24.3666585 14.5876829,24.4464146 14.7918293,24.4464146 L14.7932927,24.4464146 C15.2162195,24.4464146 15.560122,24.1025122 15.560122,23.6803171 C15.560122,23.4051951 15.1913415,22.5234878 14.7932927,21.7090976 Z M14.7918293,24.9951951 C14.4413415,24.9951951 14.1106098,24.8583659 13.8632927,24.6103171 C13.6152439,24.3615366 13.4776829,24.0315366 13.4776829,23.6803171 C13.4776829,23.0883659 14.3191463,21.4208049 14.487439,21.093 C14.5503659,20.9751951 14.6681707,20.9100732 14.7976829,20.9064146 C14.9220732,20.9064146 15.0413415,20.9795854 15.0991463,21.0944634 C15.2689024,21.4259268 16.1089024,23.090561 16.1089024,23.6803171 C16.1089024,24.405439 15.5184146,24.9951951 14.7932927,24.9951951 L14.7918293,24.9951951 Z", id: "Fill-1" }), (0,jsx_runtime.jsx)("path", { d: "M8.67241463,21.3407561 C8.67168293,21.3422195 8.67095122,21.3436829 8.67095122,21.3451463 C8.67168293,21.3436829 8.67168293,21.3422195 8.67241463,21.3407561 Z M8.48802439,21.7095366 C8.0892439,22.5246585 7.72119512,23.4056341 7.72119512,23.6800244 C7.72119512,23.8849024 7.80168293,24.0773415 7.94656098,24.2222195 C8.09070732,24.3670976 8.28241463,24.4468537 8.48656098,24.4468537 L8.48802439,24.4468537 C8.91095122,24.4468537 9.25485366,24.1029512 9.25485366,23.6800244 C9.25485366,23.4056341 8.88607317,22.5239268 8.48802439,21.7095366 Z M8.48656098,24.9956341 C8.13607317,24.9956341 7.80534146,24.8588049 7.55802439,24.6100244 C7.30997561,24.3612439 7.17241463,24.0312439 7.17241463,23.6800244 C7.17241463,23.0902683 8.01460976,21.4212439 8.18290244,21.0927073 C8.23997561,20.9778293 8.33217073,20.8856341 8.49241463,20.9068537 C8.61680488,20.9068537 8.73607317,20.9800244 8.79387805,21.0941707 C8.96363415,21.4256341 9.80363415,23.091 9.80363415,23.6800244 C9.80363415,24.4051463 9.21314634,24.9956341 8.48802439,24.9956341 L8.48656098,24.9956341 Z", id: "Fill-3" }), (0,jsx_runtime.jsx)("path", { d: "M21.0978293,21.7094634 C20.7480732,22.4258049 20.3317317,23.3792195 20.3317317,23.6799512 C20.3317317,23.885561 20.4122195,24.0772683 20.5563659,24.2221463 C20.7012439,24.3670244 20.8929512,24.4467805 21.0970976,24.4467805 L21.098561,24.4467805 C21.5207561,24.4467805 21.8646585,24.102878 21.8646585,23.6799512 C21.8646585,23.3792195 21.4483171,22.428 21.0978293,21.7094634 Z M21.0970976,24.995561 C20.7466098,24.995561 20.415878,24.8587317 20.1678293,24.6099512 C19.9205122,24.3626341 19.7829512,24.0319024 19.7829512,23.6799512 C19.7829512,23.0887317 20.6244146,21.4211707 20.7927073,21.0926341 C20.8556341,20.975561 20.9705122,20.910439 21.1029512,20.9067805 C21.2266098,20.9067805 21.3451463,20.9792195 21.4036829,21.0926341 C21.5719756,21.4211707 22.413439,23.0887317 22.413439,23.6799512 C22.413439,24.4058049 21.8236829,24.995561 21.098561,24.995561 L21.0970976,24.995561 Z", id: "Fill-5" }), (0,jsx_runtime.jsx)("path", { d: "M23.8974878,18.1570244 L5.68895122,18.1570244 C5.54773171,18.1570244 5.43358537,18.042878 5.43358537,17.9009268 C5.43358537,17.7597073 5.54773171,17.6448293 5.68895122,17.6448293 L23.8974878,17.6448293 C24.0387073,17.6448293 24.1543171,17.7597073 24.1543171,17.9009268 C24.1543171,18.042878 24.0387073,18.1570244 23.8974878,18.1570244", id: "Fill-7" }), (0,jsx_runtime.jsx)("path", { d: "M16.3331707,9.1764878 C16.2629268,9.1764878 16.1926829,9.14941463 16.1385366,9.096 L14.7936585,7.74965854 L13.4480488,9.096 C13.3404878,9.20356098 13.1663415,9.20356098 13.0587805,9.096 C12.9526829,8.98917073 12.9519512,8.81502439 13.0587805,8.70819512 L14.5990244,7.16795122 C14.7021951,7.06478049 14.885122,7.06478049 14.987561,7.16795122 L16.5278049,8.70819512 C16.6346341,8.81502439 16.6339024,8.98917073 16.5278049,9.096 C16.4736585,9.14941463 16.4034146,9.1764878 16.3331707,9.1764878", id: "Fill-9" }), (0,jsx_runtime.jsx)("path", { d: "M14.7932927,14.8958049 C14.6418293,14.8958049 14.5189024,14.772878 14.5189024,14.6214146 L14.5189024,7.36214634 C14.5189024,7.21068293 14.6418293,7.0877561 14.7932927,7.0877561 C14.9447561,7.0877561 15.0676829,7.21068293 15.0676829,7.36214634 L15.0676829,14.6214146 C15.0676829,14.772878 14.9447561,14.8958049 14.7932927,14.8958049", id: "Fill-11" }), (0,jsx_runtime.jsx)("path", { d: "M10.0279024,9.1764878 C9.95765854,9.1764878 9.88741463,9.14941463 9.83326829,9.096 L8.48839024,7.74965854 L7.14278049,9.096 C7.03521951,9.20356098 6.86107317,9.20356098 6.7535122,9.096 C6.64741463,8.98917073 6.64668293,8.81502439 6.7535122,8.70819512 L8.2937561,7.16795122 C8.39692683,7.06478049 8.57985366,7.06478049 8.68229268,7.16795122 L10.2225366,8.70819512 C10.3293659,8.81502439 10.3286341,8.98917073 10.2225366,9.096 C10.1683902,9.14941463 10.0981463,9.1764878 10.0279024,9.1764878", id: "Fill-13" }), (0,jsx_runtime.jsx)("path", { d: "M8.48802439,14.8958049 C8.33656098,14.8958049 8.21363415,14.772878 8.21363415,14.6214146 L8.21363415,7.36214634 C8.21363415,7.21068293 8.33656098,7.0877561 8.48802439,7.0877561 C8.6394878,7.0877561 8.76241463,7.21068293 8.76241463,7.36214634 L8.76241463,14.6214146 C8.76241463,14.772878 8.6394878,14.8958049 8.48802439,14.8958049", id: "Fill-15" }), (0,jsx_runtime.jsx)("path", { d: "M22.638439,9.1764878 C22.5681951,9.1764878 22.4979512,9.14941463 22.4438049,9.096 L21.0989268,7.74965854 L19.7533171,9.096 C19.6457561,9.20356098 19.4716098,9.20356098 19.3640488,9.096 C19.2579512,8.98917073 19.2572195,8.81502439 19.3640488,8.70819512 L20.9042927,7.16795122 C21.0074634,7.06478049 21.1903902,7.06478049 21.2928293,7.16795122 L22.8330732,8.70819512 C22.9399024,8.81502439 22.9391707,8.98917073 22.8330732,9.096 C22.7789268,9.14941463 22.7086829,9.1764878 22.638439,9.1764878", id: "Fill-17" }), (0,jsx_runtime.jsx)("path", { d: "M21.098561,14.8958049 C20.9470976,14.8958049 20.8241707,14.772878 20.8241707,14.6214146 L20.8241707,7.36214634 C20.8241707,7.21068293 20.9470976,7.0877561 21.098561,7.0877561 C21.2500244,7.0877561 21.3729512,7.21068293 21.3729512,7.36214634 L21.3729512,14.6214146 C21.3729512,14.772878 21.2500244,14.8958049 21.098561,14.8958049", id: "Fill-19" }), (0,jsx_runtime.jsx)("path", { d: "M15.0018463,1.11084871 C14.9773314,1.11084871 14.9535593,1.11084871 14.9283015,1.11084871 C6.94385832,1.15096261 0.480084618,7.67838616 0.519457104,15.6625387 C0.559572468,23.6221772 7.04786112,30.0708586 14.9988748,30.0708586 C15.0226469,30.0708586 15.0479047,30.0708586 15.0716767,30.0708586 C18.9398378,30.0515445 22.5687925,28.5272162 25.2906942,25.7794138 C28.0118531,23.0308685 29.4998359,19.3871889 29.4805211,15.5191686 C29.4612063,11.6511483 27.9375654,8.02306859 25.1889201,5.30126594 C22.4581038,2.59729169 18.8425209,1.11084871 15.0018463,1.11084871 Z M14.9988748,30.5908537 C6.76185343,30.5915965 0.0403013706,23.9111458 0.000186006853,15.6655101 C-0.040672234,7.39387458 6.65487913,0.631710412 14.92533,0.590853659 L15.0018463,0.590853659 C18.9806961,0.590853659 22.7255396,2.13078185 25.5544156,4.93206946 C28.4018636,7.75118546 29.9804774,11.5100068 29.9997922,15.5169401 C30.0205928,19.5231305 28.4791228,23.2975517 25.6599041,26.144896 C22.8406855,28.9922403 19.0809845,30.5707967 15.0746483,30.5908537 L14.9988748,30.5908537 Z", id: "Fill-19", stroke: "#00174F", strokeWidth: 0.5 })] }) })) })) }))] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-benefits-moisturewicking-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("title", { children: 'Moisture Wicking Icon ' }), (0,jsx_runtime.jsx)("desc", { children: 'Created with Sketch.' }), (0,jsx_runtime.jsx)("defs", {}), (0,jsx_runtime.jsx)("g", Object.assign({ id: "Spots-Flow", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Icons-", transform: "translate(-507.000000, -349.000000)", fill: "#00285E" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Moisture-Wicking-Icon-", transform: "translate(508.000000, 349.000000)" }, { children: (0,jsx_runtime.jsxs)("g", { children: [(0,jsx_runtime.jsx)("path", { d: "M14.7932927,21.7090976 C14.4435366,22.425439 14.0264634,23.3788537 14.0264634,23.6803171 C14.0264634,23.8851951 14.1069512,24.0769024 14.2518293,24.2225122 C14.3959756,24.3666585 14.5876829,24.4464146 14.7918293,24.4464146 L14.7932927,24.4464146 C15.2162195,24.4464146 15.560122,24.1025122 15.560122,23.6803171 C15.560122,23.4051951 15.1913415,22.5234878 14.7932927,21.7090976 Z M14.7918293,24.9951951 C14.4413415,24.9951951 14.1106098,24.8583659 13.8632927,24.6103171 C13.6152439,24.3615366 13.4776829,24.0315366 13.4776829,23.6803171 C13.4776829,23.0883659 14.3191463,21.4208049 14.487439,21.093 C14.5503659,20.9751951 14.6681707,20.9100732 14.7976829,20.9064146 C14.9220732,20.9064146 15.0413415,20.9795854 15.0991463,21.0944634 C15.2689024,21.4259268 16.1089024,23.090561 16.1089024,23.6803171 C16.1089024,24.405439 15.5184146,24.9951951 14.7932927,24.9951951 L14.7918293,24.9951951 Z", id: "Fill-1" }), (0,jsx_runtime.jsx)("path", { d: "M8.67241463,21.3407561 C8.67168293,21.3422195 8.67095122,21.3436829 8.67095122,21.3451463 C8.67168293,21.3436829 8.67168293,21.3422195 8.67241463,21.3407561 Z M8.48802439,21.7095366 C8.0892439,22.5246585 7.72119512,23.4056341 7.72119512,23.6800244 C7.72119512,23.8849024 7.80168293,24.0773415 7.94656098,24.2222195 C8.09070732,24.3670976 8.28241463,24.4468537 8.48656098,24.4468537 L8.48802439,24.4468537 C8.91095122,24.4468537 9.25485366,24.1029512 9.25485366,23.6800244 C9.25485366,23.4056341 8.88607317,22.5239268 8.48802439,21.7095366 Z M8.48656098,24.9956341 C8.13607317,24.9956341 7.80534146,24.8588049 7.55802439,24.6100244 C7.30997561,24.3612439 7.17241463,24.0312439 7.17241463,23.6800244 C7.17241463,23.0902683 8.01460976,21.4212439 8.18290244,21.0927073 C8.23997561,20.9778293 8.33217073,20.8856341 8.49241463,20.9068537 C8.61680488,20.9068537 8.73607317,20.9800244 8.79387805,21.0941707 C8.96363415,21.4256341 9.80363415,23.091 9.80363415,23.6800244 C9.80363415,24.4051463 9.21314634,24.9956341 8.48802439,24.9956341 L8.48656098,24.9956341 Z", id: "Fill-3" }), (0,jsx_runtime.jsx)("path", { d: "M21.0978293,21.7094634 C20.7480732,22.4258049 20.3317317,23.3792195 20.3317317,23.6799512 C20.3317317,23.885561 20.4122195,24.0772683 20.5563659,24.2221463 C20.7012439,24.3670244 20.8929512,24.4467805 21.0970976,24.4467805 L21.098561,24.4467805 C21.5207561,24.4467805 21.8646585,24.102878 21.8646585,23.6799512 C21.8646585,23.3792195 21.4483171,22.428 21.0978293,21.7094634 Z M21.0970976,24.995561 C20.7466098,24.995561 20.415878,24.8587317 20.1678293,24.6099512 C19.9205122,24.3626341 19.7829512,24.0319024 19.7829512,23.6799512 C19.7829512,23.0887317 20.6244146,21.4211707 20.7927073,21.0926341 C20.8556341,20.975561 20.9705122,20.910439 21.1029512,20.9067805 C21.2266098,20.9067805 21.3451463,20.9792195 21.4036829,21.0926341 C21.5719756,21.4211707 22.413439,23.0887317 22.413439,23.6799512 C22.413439,24.4058049 21.8236829,24.995561 21.098561,24.995561 L21.0970976,24.995561 Z", id: "Fill-5" }), (0,jsx_runtime.jsx)("path", { d: "M23.8974878,18.1570244 L5.68895122,18.1570244 C5.54773171,18.1570244 5.43358537,18.042878 5.43358537,17.9009268 C5.43358537,17.7597073 5.54773171,17.6448293 5.68895122,17.6448293 L23.8974878,17.6448293 C24.0387073,17.6448293 24.1543171,17.7597073 24.1543171,17.9009268 C24.1543171,18.042878 24.0387073,18.1570244 23.8974878,18.1570244", id: "Fill-7" }), (0,jsx_runtime.jsx)("path", { d: "M16.3331707,9.1764878 C16.2629268,9.1764878 16.1926829,9.14941463 16.1385366,9.096 L14.7936585,7.74965854 L13.4480488,9.096 C13.3404878,9.20356098 13.1663415,9.20356098 13.0587805,9.096 C12.9526829,8.98917073 12.9519512,8.81502439 13.0587805,8.70819512 L14.5990244,7.16795122 C14.7021951,7.06478049 14.885122,7.06478049 14.987561,7.16795122 L16.5278049,8.70819512 C16.6346341,8.81502439 16.6339024,8.98917073 16.5278049,9.096 C16.4736585,9.14941463 16.4034146,9.1764878 16.3331707,9.1764878", id: "Fill-9" }), (0,jsx_runtime.jsx)("path", { d: "M14.7932927,14.8958049 C14.6418293,14.8958049 14.5189024,14.772878 14.5189024,14.6214146 L14.5189024,7.36214634 C14.5189024,7.21068293 14.6418293,7.0877561 14.7932927,7.0877561 C14.9447561,7.0877561 15.0676829,7.21068293 15.0676829,7.36214634 L15.0676829,14.6214146 C15.0676829,14.772878 14.9447561,14.8958049 14.7932927,14.8958049", id: "Fill-11" }), (0,jsx_runtime.jsx)("path", { d: "M10.0279024,9.1764878 C9.95765854,9.1764878 9.88741463,9.14941463 9.83326829,9.096 L8.48839024,7.74965854 L7.14278049,9.096 C7.03521951,9.20356098 6.86107317,9.20356098 6.7535122,9.096 C6.64741463,8.98917073 6.64668293,8.81502439 6.7535122,8.70819512 L8.2937561,7.16795122 C8.39692683,7.06478049 8.57985366,7.06478049 8.68229268,7.16795122 L10.2225366,8.70819512 C10.3293659,8.81502439 10.3286341,8.98917073 10.2225366,9.096 C10.1683902,9.14941463 10.0981463,9.1764878 10.0279024,9.1764878", id: "Fill-13" }), (0,jsx_runtime.jsx)("path", { d: "M8.48802439,14.8958049 C8.33656098,14.8958049 8.21363415,14.772878 8.21363415,14.6214146 L8.21363415,7.36214634 C8.21363415,7.21068293 8.33656098,7.0877561 8.48802439,7.0877561 C8.6394878,7.0877561 8.76241463,7.21068293 8.76241463,7.36214634 L8.76241463,14.6214146 C8.76241463,14.772878 8.6394878,14.8958049 8.48802439,14.8958049", id: "Fill-15" }), (0,jsx_runtime.jsx)("path", { d: "M22.638439,9.1764878 C22.5681951,9.1764878 22.4979512,9.14941463 22.4438049,9.096 L21.0989268,7.74965854 L19.7533171,9.096 C19.6457561,9.20356098 19.4716098,9.20356098 19.3640488,9.096 C19.2579512,8.98917073 19.2572195,8.81502439 19.3640488,8.70819512 L20.9042927,7.16795122 C21.0074634,7.06478049 21.1903902,7.06478049 21.2928293,7.16795122 L22.8330732,8.70819512 C22.9399024,8.81502439 22.9391707,8.98917073 22.8330732,9.096 C22.7789268,9.14941463 22.7086829,9.1764878 22.638439,9.1764878", id: "Fill-17" }), (0,jsx_runtime.jsx)("path", { d: "M21.098561,14.8958049 C20.9470976,14.8958049 20.8241707,14.772878 20.8241707,14.6214146 L20.8241707,7.36214634 C20.8241707,7.21068293 20.9470976,7.0877561 21.098561,7.0877561 C21.2500244,7.0877561 21.3729512,7.21068293 21.3729512,7.36214634 L21.3729512,14.6214146 C21.3729512,14.772878 21.2500244,14.8958049 21.098561,14.8958049", id: "Fill-19" }), (0,jsx_runtime.jsx)("path", { d: "M15.0018463,1.11084871 C14.9773314,1.11084871 14.9535593,1.11084871 14.9283015,1.11084871 C6.94385832,1.15096261 0.480084618,7.67838616 0.519457104,15.6625387 C0.559572468,23.6221772 7.04786112,30.0708586 14.9988748,30.0708586 C15.0226469,30.0708586 15.0479047,30.0708586 15.0716767,30.0708586 C18.9398378,30.0515445 22.5687925,28.5272162 25.2906942,25.7794138 C28.0118531,23.0308685 29.4998359,19.3871889 29.4805211,15.5191686 C29.4612063,11.6511483 27.9375654,8.02306859 25.1889201,5.30126594 C22.4581038,2.59729169 18.8425209,1.11084871 15.0018463,1.11084871 Z M14.9988748,30.5908537 C6.76185343,30.5915965 0.0403013706,23.9111458 0.000186006853,15.6655101 C-0.040672234,7.39387458 6.65487913,0.631710412 14.92533,0.590853659 L15.0018463,0.590853659 C18.9806961,0.590853659 22.7255396,2.13078185 25.5544156,4.93206946 C28.4018636,7.75118546 29.9804774,11.5100068 29.9997922,15.5169401 C30.0205928,19.5231305 28.4791228,23.2975517 25.6599041,26.144896 C22.8406855,28.9922403 19.0809845,30.5707967 15.0746483,30.5908537 L14.9988748,30.5908537 Z", id: "Fill-19", stroke: "#00174F", strokeWidth: 0.5 })] }) })) })) }))] })));
};

})();

var __webpack_exports__IconBenefitsMoisturewicking = __webpack_exports__.c;
export { __webpack_exports__IconBenefitsMoisturewicking as IconBenefitsMoisturewicking };
